import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import CookieConsent from "react-cookie-consent";
import { updateTranslation } from "../../actions/TranslationActions";

export default connect((state) => state, { updateTranslation })(
  withRouter(({ children, updateTranslation, _ }) => (
    <>
      {children}
      {false && (
        <CookieConsent
          containerClasses="cookie-consent"
          contentClasses="cookie-consent-content"
          disableStyles={true}
          buttonText="&times;"
          buttonClasses="cookie-consent-button"
        >
          {_.CookieConsent}
        </CookieConsent>
      )}
    </>
  ))
);
